angular.module('registerAppDirectives', [])
.directive('compareTo', function() {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=compareTo"
        },
        link: function(scope, element, attributes, ngModel) {

            ngModel.$validators.compareTo = function(modelValue) {
                return modelValue == scope.otherModelValue;
            };

            scope.$watch("otherModelValue", function() {
                ngModel.$validate();
            });
        }
    };
})
   /* .directive('uniqueUserEmail', function() {
        return {
            require: "ngModel",
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.unique_user_email = function() {
                    return true;
                };
            }
        };
    })*/
    .directive('checkPassword', function() {
        return {
            link: function(scope, element, attributes) {

                if ( typeof attributes == "undefined" || attributes === null
                    || typeof attributes.passwordid == "undefined" || $.trim(attributes.passwordid).length == 0
                ) {
                    return false;
                }

                var el = $('#' + attributes.passwordid);
                UserPassword.initCheckPasswordFunction(el);
            },
            template: '<div class="form-group"><div id="pwd_bar"></div><span id="pwd_meter"></span></div>'
        };
    })
    .directive('addPopover', function() {
        return {
            link: function(scope, element, attributes) {
               element.popover();
            }

        };
    })
    .directive('uniqueChainName', function() {
        return {
            require: "ngModel",
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.unique_chain_name = function() {
                    return true;
                };
            }
        };
    }).directive('validateChainSubdomain', function() {
        return {
            require: "ngModel",
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.validate_chain_subdomain = function() {
                    return true;
                };
            }
        };
    }).directive('preventPressEnter', function ($timeout) {

    var linker = function (scope, element) {
        $timeout(function () {
            element.on('keydown', function (event) {
                var ENTER_KEY = 13;
                return !(typeof event != 'undefined' && event.keyCode == ENTER_KEY);
            });
        });
    };

    return {
        restrict: 'A',
        link: linker
    };
});